const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const newsletterService = {
  async subscribe(email) {
    const response = await fetch(`${API_URL}/api/newsletter/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Subscription failed');
    }

    return data;
  },
};
